import privacyNotice from 'assets/documents/digitalLoan/privacy-notice-app-mls-2026.pdf';
import proximityLoanTerms from 'assets/documents/digitalLoan/proximity-loan-terms-2026.pdf';
import creditBureauAuthorization from 'assets/documents/digitalLoan/credit-bureau-authorization.pdf';

/**
 * Documentos legales estáticos de Préstamo de cercanía.
 * El título visible vive en i18n (`digitalLoan.permissions.labels`).
 */
const DIGITAL_LOAN_LEGAL_DOCUMENTS = {
  privacy: {
    id: 'PRIVACY',
    file: privacyNotice,
  },
  terms: {
    id: 'TERMS',
    file: proximityLoanTerms,
  },
  bureau: {
    id: 'CREDIT_BUREAU',
    file: creditBureauAuthorization,
  },
};

export default DIGITAL_LOAN_LEGAL_DOCUMENTS;
